import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { constant } from '@login/resources/constant';
import { ResetPasswordService } from '@login/services/reset-password.service';
import { ApiConstants } from '@login/util/api-constants';
import { AlertService } from '@shared/services/alert.service';
import { SpinnerService } from '@shared/services/spinner.service';

@Component({
  selector: 'app-challenge-question',
  templateUrl: './challenge-question.component.html',
  styleUrls: ['./challenge-question.component.scss'],
})
export class ChallengeQuestionComponent implements OnInit {
  isValidRecoveryToken = true;
  invalidRecoveryTokenErrMsg: string;

  constructor(
    private resetPasswordService: ResetPasswordService,
    private router: Router,
    private spinnerService: SpinnerService,
    private alertService: AlertService,
  ) {}

  ngOnInit() {}

  onVerifyRecoveryAnswerSuccess(response) {
    this.alertService.clearAlert();
    this.router.navigate(['/login/reset-password'], {
      queryParamsHandling: 'preserve',
    });
  }

  onVerifyRecoveryAnswerError(err) {
    let errorMessage;
    switch (err.error.errorCode) {
      case 'ERRPRS023':
        errorMessage = ApiConstants.CHALLENGE_ANSWER_ERROR;
        break;
      case 'ERRPRS020':
        errorMessage = ApiConstants.ACCOUNT_LOCKED_ERROR;
        break;
      case 'ERRPRS025':
        errorMessage = ApiConstants.INVALID_STATE_TOKEN_ERROR;
        break;
      case 'ERRPRS010':
      case 'ERRPRS011':
        errorMessage = err.error.statusText;
        break;
      default:
        errorMessage = constant.ON_VRFY_REC_ANS_CALL_FAILURE_0;
        break;
    }
    this.alertService.setAlert(errorMessage);
  }

  onIsValidRecoveryToken({ isValid, err }) {
    this.alertService.clearAlert();
    this.isValidRecoveryToken = isValid;
    if (!isValid) {
      if (err.error.errorCode === 'ERRPRS022') {
        this.invalidRecoveryTokenErrMsg =
          ApiConstants.EXPIRED_RECOVERY_TOKEN_ERROR;
      } else {
        this.invalidRecoveryTokenErrMsg =
          ApiConstants.INVALID_RECOVERY_TOKEN_ERROR;
      }
    }
  }
}
